import React from 'react';

const TOTAL_PAGE_BTNS_DISPLAYED = 5;

// conditionally returns the 5 page buttons to be displayed
const getPagesArr = (pagesArray, activePage) => {
	if (activePage < 5) {
		return pagesArray.filter(pageNumber => pageNumber <= TOTAL_PAGE_BTNS_DISPLAYED);
	}

	if (activePage > pagesArray.length - (TOTAL_PAGE_BTNS_DISPLAYED - 1)) {
		return pagesArray.filter(pageNumber => pageNumber >= pagesArray.length - (TOTAL_PAGE_BTNS_DISPLAYED - 1));
	}

	const firstTwoPages = pagesArray.filter(pageNumber => pageNumber < activePage && pageNumber >= (activePage - 2));
	const lastTwoPages = pagesArray.filter(pageNumber => pageNumber >= activePage && pageNumber <= (activePage + 2));
	return [...firstTwoPages, ...lastTwoPages];
}

// displays the pagination
export const renderPages = (pagesArray, activePage) => {
	if (!pagesArray.length) return null;

	const filteredPagesArr = getPagesArr(pagesArray, activePage);
	
	return filteredPagesArr.map(pageNumber => {
		return <li className='collection-pagination__container' key={pageNumber}><button className='collection-pagination__button' type="button" value={pageNumber} disabled={activePage === pageNumber && 'disabled'}>{pageNumber}</button></li>
	});
}

export const handlePageClick = (event, activePage, paramsSetterFn, activePageSetterFn, setClickedBtnVal) => {
	const value = event.target.value;
	
	if (!value) return;

	// increments the activePage value on click of the next arrow
	if (value === 'next') {
		paramsSetterFn(prevParams => {
			return {...prevParams, p: activePage + 1};
		});
		activePageSetterFn(prevActivePage => parseInt(prevActivePage) + 1);
	}

	// decrements the activePage value on click of the prev arrow
	if (value === 'prev') {
		paramsSetterFn(prevParams => {
			return {...prevParams, p: activePage - 1};
		});
		activePageSetterFn(prevActivePage => parseInt(prevActivePage) - 1);
	}

	// sets the active page value 
	if (value !== 'next' && value !== 'prev') {
		const numValue = parseInt(value);
		paramsSetterFn(prevParams => {
			return {...prevParams, p: value};
		});
		activePageSetterFn(numValue);
	}	

	setClickedBtnVal(value);
}

// renders the next arrow when there is more than one page
// and the active page is not the last page
export const renderNextArrow = (pagesArray, activePage) => {
	if (!pagesArray.length) return null;

	if (pagesArray.length > 1 && activePage !== pagesArray[pagesArray.length-1]) {
		return (
			<li className='collection-pagination__container'><button className='collection-pagination__button' aria-label='next' type="button" value='next'></button></li>
		)
	}
}

// conditionally renders the ellipsis and last page button
// when the active page is four and below
export const renderLastPage = (pagesArray, activePage) => {
	if (!pagesArray.length) return null;

	if (pagesArray.length > TOTAL_PAGE_BTNS_DISPLAYED ) {
		if (activePage < TOTAL_PAGE_BTNS_DISPLAYED  || (activePage >= TOTAL_PAGE_BTNS_DISPLAYED  && activePage <= pagesArray.length - (TOTAL_PAGE_BTNS_DISPLAYED - 1))) {
			const value = pagesArray[pagesArray.length-1];
			return (
				<>
					<li className='collection-pagination__dots'>&hellip;</li>
					<li className='collection-pagination__container'><button className='collection-pagination__button' type="button" value={value}>{value}</button></li>
				</>
			)
		}
	}
}

// renders the prev arrow when there is more than one page
// and the active page is 2 and above
export const renderPrevArrow = (pagesArray, activePage) => {
	if (!pagesArray.length) return null;

	if (pagesArray.length > 1 && activePage !== 1) {
		return (
			<li className='collection-pagination__container'><button className='collection-pagination__button' aria-label='previous' type="button" value='prev'></button></li>
		)
	}
}

// renders the ellipsis and first page button when the active page 5 and above
export const renderFirstPage = (pagesArray, activePage) => {
	if (!pagesArray.length) return null;

	if (pagesArray.length > TOTAL_PAGE_BTNS_DISPLAYED) {
		if (activePage > pagesArray.length - (TOTAL_PAGE_BTNS_DISPLAYED - 2) || activePage >= TOTAL_PAGE_BTNS_DISPLAYED) {
			const value = pagesArray[0];
			return (
				<>
					<li className='collection-pagination__container'><button className='collection-pagination__button' type="button" value={value}>{value}</button></li>
					<li className='collection-pagination__dots'>&hellip;</li>
				</>
			)
		}
	}
}